import { ensure, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { CloudAssetQueryKey } from "../../../../assets/details/cloud-asset/common/CloudAssetQueryKey";
import { useAssetsApi } from "../../../../common/api/master-api/assets/useAssetsApi";
import { AssetOperationListItem, mapToAssetOperationListItem } from "../AssetOperationListItem";

export const useCloudAssetOperations = (cloudFileId?: string): SprintQueryResult<AssetOperationListItem[]> => {
    const { getCloudAssetsOperations } = useAssetsApi();

    return useSprintQuery<AssetOperationListItem[]>({
        queryKey: [CloudAssetQueryKey.CloudAssetOperations, cloudFileId],
        queryFn: async (): Promise<AssetOperationListItem[]> => {
            try {
                ensure(cloudFileId, "Cloud File ID is required to fetch cloud asset operations.");

                const response = await getCloudAssetsOperations({ cloudFileId });

                return response.items.map(mapToAssetOperationListItem);
            } catch (error) {
                console.error("Failed to fetch cloud asset operations.", error);

                return [];
            }
        },
        options: {
            cacheTime: 0
        }
    });
};
